import React from "react";
import Lottie from "react-lottie";

interface LottieAnimationInterface {
  isActive: boolean;
  lottiAnimation: any;
  height?: number;
  width?: number;
}

const LottieAnimation: React.FunctionComponent<LottieAnimationInterface> = (
  props
) => {
  const defaultOptions = {
    loop: true,
    autoplay: props.isActive,
    animationData: props.lottiAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Lottie
      options={defaultOptions}
      width={props.width}
      height={props.height}
      isClickToPauseDisabled={true}
    />
  );
};

export default LottieAnimation;
